import BuyerSidebarPreferenceToggle from "@/components/BuyerSidebarPreferenceToggle";
import BuyerModuleVisibilityPanel from "@/components/BuyerModuleVisibilityPanel";
import AppBackgroundThemePanel from "@/components/AppBackgroundThemePanel";
import BuyerAsistenteClientesUnderConstructionToggle from "@/components/BuyerAsistenteClientesUnderConstructionToggle";

/**
 * Preferencias de UI del diseñador BNT — visible en hub Diseñador y Herramientas Técnicas.
 */
export default function DesignerBuyerUxPreferences({ showSidebarToggle = true } = {}) {
  return (
    <section
      aria-label="Preferencias de interfaz para compradores"
      data-testid="designer-buyer-ux-preferences"
      className="space-y-4 rounded-md border border-[#0F2D5C]/15 bg-white p-4 shadow-sm"
    >
      <div>
        <h2 className="text-sm font-bold uppercase tracking-wider text-[#0F2D5C] m-0">
          Visibilidad, navegación y apariencia
        </h2>
        <p className="text-xs text-slate-600 mt-1 m-0 max-w-3xl leading-relaxed">
          Controle qué módulos ve el comprador, el menú lateral, el fondo decorativo y avisos «en
          construcción». Use «vista de prueba como comprador» para validar. Estos controles no aparecen
          para el comprador final.
        </p>
      </div>
      {showSidebarToggle ? <BuyerSidebarPreferenceToggle /> : null}
      <BuyerAsistenteClientesUnderConstructionToggle />
      <BuyerModuleVisibilityPanel />
      <AppBackgroundThemePanel />
    </section>
  );
}
